import React from 'react'
import BaseQuery from '../../BaseQuery'
import { BaseQueryChildrenType } from '../../types/BaseQueryChildrenType'
import { gql } from '@apollo/client'
import { useParams } from 'react-router-dom'
import TranscriptPage from './TranscriptPage'
import {getDatasetId} from '@/utils/paramUtils'

const query = gql`
    query Transcript($transcriptId: String!, $datasetId: String!) {
        transcript(transcript_id: $transcriptId, dataset_id: $datasetId) {
            transcript_id
            chrom
            start
            gene_id
            gene_symbol
            stop
            variants {
                chrom
                ref
                alt
                length
                transcript_id_canonical
                transcript_consequence_major {
                    gene_symbol
                    gene_id
                    consequence
                    transcript_id
                }
                source
                pos
                variant_id
                czechgenome_genome_frequencies {
                    population_subtype
                    variant_id
                    allele_stats {
                        allele_count
                        allele_number
                        homozygote_count
                        allele_frequency
                    }
                }
                clinical_significance
                rsids
            }
        }
    }
`

type Params = {
    transcriptId: string
}

export default function TranscriptPageContainer() {
    const { transcriptId = '' } = useParams<Params>()
    const datasetId = getDatasetId()

    return (
        <BaseQuery
            query={query}
            variables={{
                transcriptId,
                datasetId
            }}
            loadingMessage='Loading transcript'
            notFoundMessage='Transcript not found'
        >
            {({ data }: BaseQueryChildrenType) => {
                return <TranscriptPage transcript={data.transcript} />
            }}
        </BaseQuery>
    )
}
